import * as React from 'react';

export const CheckboxGroup = ({
                                input,
                                inline,
                                showErrorLabel,
                                options,
                                meta: { touched, error },
                              }) => {

  const onChange = () => {
    input.onChange(!input.value)
  }

  return (
    <div className={touched && error ? ' has-error' : ''}>
      <div>
        {options.map((option, key) => {
          return (
            <div className={'radio-container' + (inline ? ' inline' : '')} key={key}>
              <div className={'form-radio'}>
                <label>
                  <input
                    {...input}
                    type="checkbox"
                    id={input.name + option.value}
                    checked={input.value === option.value}
                  />
                  <div className={'custom-checkbox'}/>
                  <span className="radio-label"
                        onClick={onChange}>{option.label}</span>
                </label>
              </div>

            </div>
          )
        })}
      </div>

      {showErrorLabel && touched && error && <span className="input-error">{error}</span>}
    </div>
  )
}
